import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

export const toastStyles = {
	msg: {
		height: '64px',
		padding: '8px 16px',
		borderRadius: '4px',
		backgroundColor: colorPalette.tonal3,
		display: 'flex',
		alignItems: 'center',
		gap: '16px',
	},
	icon: {
		height: '24px',
		'& svg': { height: 'inherit', width: 'auto' },
	},
	flexCol: {
		display: 'flex',
		flexDirection: 'column',
		gap: '2px',
		textAlign: 'left',
	},
	loadingAssetIndicator: {
		maxWidth: '60px',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
};
